import React, { useEffect, useState } from "react";
import { Button, Select, Table, Tooltip } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import config from "../../config";
import authHeader from "../Authentication/authHeader";
import POModal from "./POModal";
import POTemplate from "./POTemplate";

export default function POList() {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const TIMEZONE = "Asia/Dhaka";

  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [supplierList, setSupplierList] = useState([]);
  const [poList, setPoList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [visibility, setVisibility] = useState(false);
  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("userProfile"))
  );
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [poLoading, setPoLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedPoData, setSelectedPoData] = useState(null);
  const [poTemplateVisibility, setPoTemplateVisibility] = useState(false);

  const handlePODateRage = (value) => {
    if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
      // Convert to timezone first if needed
      let startDate = dayjs.tz(value[0], TIMEZONE).startOf("day");
      let endDate = dayjs.tz(value[1], TIMEZONE).endOf("day");

      // Convert to ISO string (UTC with Z)
      const formattedStartDate = startDate.toISOString();
      const formattedEndDate = endDate.toISOString();

      setSelectedDateRange([formattedStartDate, formattedEndDate]);
    } else {
      setSelectedDateRange(null);
    }
  };

  const handleSupplier = (value) => {
    setCurrentPage(1);
    setSelectedSupplier(value);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleExpenseModalVisibility = () => {
    setVisibility(true);
  };

  const handlePoModalClose = () => {
    setVisibility(false);
    setIsUpdate(false);
    setSelectedPoData(null);
  };

  const handlePoModalVisibility = (record) => {
    setVisibility(true);
    setIsUpdate(true);
    setSelectedPoData(record);
  };
  const handlePoView = (record) => {
    setPoTemplateVisibility(true);
    setSelectedPoData(record);
  };
  const handlePoTemplateClose = () => {
    setPoTemplateVisibility(false);
    setSelectedPoData(null);
  };

  const fetchPoList = () => {
    setPoLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/po_list/`, {
        headers: authHeader(),
        params: {
          supplier_id: selectedSupplier,
          dateRange: selectedDateRange,
          page: currentPage,
        },
      })
      .then((response) => {
        setPoLoading(false);
        setPoList(response?.data?.results);
        setTotalItems(response?.data?.count);
      })
      .catch((error) => {
        setPoLoading(false);
        console.log(error);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };
  useEffect(() => {
    fetchPoList();
  }, [currentPage, selectedSupplier, selectedDateRange]);

  useEffect(() => {
    setPoLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/supplier_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setPoLoading(false);
        setSupplierList(response?.data);
      })
      .catch((error) => {
        setPoLoading(true);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  const poColumn = [
    {
      title: "Date",
      render: (record) =>
        record?.created_at
          ? new Date(record?.created_at).toISOString().slice(0, 10)
          : "",
      width: "8%",
    },
    {
      title: "PO ID",
      dataIndex: "po_id",
      width: "8%",
    },
    {
      title: "Supplier Name",
      render: (record) => record?.supplier_name,
      width: "10%",
    },
    {
      title: "Initiated By",
      render: (record) => record?.initiated_by_name,
      width: "10%",
    },
    {
      title: "PO Date",
      render: (record) => record.po_date,
      width: "8%",
    },
    {
      title: "Delivery Date",
      render: (record) => record.po_date,
      width: "8%",
    },
    {
      title: "Status",
      render: (record) => record?.status,
      width: "8%",
    },
    {
      title: "Remarks",
      render: (record) => record?.remarks,
      width: "10%",
    },

    {
      title: "Action",
      width: "5%",
      render: (record) => {
        return (
          <React.Fragment>
            <div className="d-flex">
              <Tooltip title="Update">
                <Button
                  className="d-flex align-items-center me-1"
                  disabled={record?.status === "Received"}
                  onClick={() => handlePoModalVisibility(record)}
                >
                  <EditOutlined />
                </Button>
              </Tooltip>
              <Tooltip title="View">
                <Button
                  className="d-flex align-items-center"
                  onClick={() => handlePoView(record)}
                >
                  <EyeOutlined />
                </Button>
              </Tooltip>
            </div>
          </React.Fragment>
        );
      },
    },
  ];
  return (
    <>
      {visibility && (
        <POModal
          visible={visibility}
          modalClose={handlePoModalClose}
          userProfile={userProfile}
          isUpdate={isUpdate}
          data={selectedPoData}
          fetchPoList={fetchPoList}
        />
      )}
      {poTemplateVisibility && (
        <POTemplate
          visible={poTemplateVisibility}
          modalClose={handlePoTemplateClose}
          data={selectedPoData}
        />
      )}
      <div className="farmerDashboard">
        <div className="dashboardNameSection">
          <h5 style={{ color: "#46604A" }}>PURCHASE ORDER LIST</h5>
        </div>
        <div className="farmerDashboardContainer shadow-sm rounded">
          <div className="pt-5" style={{ width: "95%", margin: "auto" }}>
            <div className="shadow-sm p-3">
              <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
                <div>
                  <Select
                    placeholder="Select Supplier"
                    className="me-3"
                    onChange={handleSupplier}
                    style={{ width: "200px" }}
                  >
                    <Option value="">All Suppliers</Option>
                    {supplierList?.map((supplier) => (
                      <Option
                        value={supplier?.supplier_id}
                        key={supplier?.supplier_id}
                      >
                        {supplier?.supplier_name}
                      </Option>
                    ))}
                  </Select>

                  <RangePicker
                    onChange={handlePODateRage}
                    value={
                      selectedDateRange
                        ? selectedDateRange.map((date) => dayjs(date))
                        : null
                    }
                    style={{ width: "250px" }}
                  />
                </div>

                <Button
                  style={{
                    backgroundColor: "#46604A",
                    borderColor: "#46604A",
                    color: "white",
                  }}
                  onClick={handleExpenseModalVisibility}
                >
                  Add Purchase Order
                </Button>
              </div>
              <Table
                className="border"
                size="small"
                columns={poColumn}
                dataSource={poList}
                loading={poLoading}
                rowKey={(record) => record?.po_id}
                pagination={{
                  current: currentPage,
                  pageSize: 10,
                  total: totalItems,
                  onChange: handlePageChange,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
